window.Pikaday = require("pikaday");
